import Snackbar from "@mui/joy/Snackbar";
import { X } from "feather-icons-react/build/IconComponents";
import { useEffect, useState } from "react";
import {
  CheckCircleFill,
  ExclamationCircleFill,
  XCircleFill,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { decryptData } from "../controllers/encryptionUtils";
import { ButtonComponent } from "@shopeasy-dashboard-ui/ui-library";

const Notification = ({
  message,
  close,
  severity,
  handlestoreDeleteRequestPending,
}) => {
  const [open, setopen] = useState(true);
  const [msg, setMsg] = useState("");
  const handleClose = () => {
    close();
    setopen(false);
    setMsg("");
  };
  const ERROR_MESSAGE_STATUS_CODE = [
    401,
    402,
    403,
    404,
    408,
    409,
    422,
    498,
    882,
  ];
  const INTERNAL_SERVER_ERROR = [
    400,
    500,
  ];

  const navigate = useNavigate();
  useEffect(() => {
    if (
      message?.response &&
      ERROR_MESSAGE_STATUS_CODE?.includes(message?.response?.status)
    ) {
      if (message?.response?.status === 401) {
        navigate("/");
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        localStorage.removeItem("business_name");
      }
      const result = decryptData(message?.response?.data);
      setMsg(result?.error ?? result?.message);
    } else if (
      message?.response &&
      INTERNAL_SERVER_ERROR?.includes(message?.response?.status)
    ) {
      setMsg("Something went wrong!");
    } else if (message?.response && message?.response?.status === 405) {
    } else {
      setMsg(message);
    }
  }, [message]);
  return (
    <Snackbar
      startDecorator={
        severity === "error" ? (
          <XCircleFill className="w-6 h-5" />
        ) : severity === "warning" ? (
          <ExclamationCircleFill className="w-6 h-5" />
        ) : (
          <CheckCircleFill className="w-6 h-5" />
        )
      }
      endDecorator={
        <ButtonComponent
          variant="ghost"
          size="sm"
          onClick={() => handleClose()}
          icon={<X className="w-4 h-4" />}
          className="!p-0.5 text-current"
        />
      }
      size="md"
      variant="soft"
      open={open && msg?.length > 0}
      color={severity === "error" ? "danger" : severity}
      autoHideDuration={severity === "success" ? 3000 : null}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      {msg}
    </Snackbar>
  );
};
export default Notification;
